import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from "../../Config.jsx";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerRegData } from '../../Redux/action/Admin/CustomerAction.js';
import Beatloader from '../../Common/Loaders/Beatloader.jsx';



const RenewalModal = ({ contract_id, handleClose, show, refresh, ContractInfo, CustomerProfileData, loadingContractInfoAdmin }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showWholeForm, setShowWholeForm] = useState(false);
    const [showRejectionForm, setShowRejectionForm] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);


    useEffect(() => {
        if (loadingContractInfoAdmin) {
            setShowLoader(true);
        } else {
            setShowLoader(false);

        }
    }, [loadingContractInfoAdmin])

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            approval: "",
            committed_witness_name: "",
            committed_witness_address: "",
            committed_witness_signature: "",
            rejection_reason: "",
        },
        validationSchema: Yup.object({}),
        onSubmit: async (values, { resetForm }) => {
            values.id = contract_id
            values.customer_id = CustomerProfileData.id;
            if (!values.id || !values.customer_id) {
                toast.error("Internal server error!")
                return;
            }
            setIsSubmitting(true);
            try {
                axios.post(`${adminMainUrl}/api/customer/contract/update`,
                    values, // The request payload
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'auth-token': Cookies.get('token'), // Assuming the token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        }
                    }
                ).then(response => {
                    if (response.status === 200) { // Check if the response is OK
                        toast.success(response.data?.msg);
                        handleClose();
                        setIsSubmitting(false);
                        resetForm();
                        formik.setFieldValue("approval", "")
                        formik.setFieldValue("committed_witness_signature", "");
                        refresh();
                    } else {
                        toast.error(response.data?.msg);
                    }
                }).catch(error => {
                    setIsSubmitting(false);
                    if (error.response) {
                        toast.error(error.response.data?.msg || "An error occurred.");
                        console.error('Error disapproving document:', error.response.data?.message);
                    } else {
                        toast.error("Network error or server is unreachable.");
                        console.error('Network error:', error);
                    }
                });
            } catch (error) {
                setIsSubmitting(false);
                console.error('Network error:', error);
            }
        },
    });



    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            {showLoader ?
                <Beatloader />
                :
                <>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Renew Contract</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="mb-3 mt-3">
                                <>
                                    <div className="row">
                                        <div className="col-md-12 my-2">
                                            <label htmlFor="committed_witness_name" className='form-label'>Committed Witness Name: <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" className="form-control form-control-sm"
                                                name="committed_witness_name"
                                                id="committed_witness_name"
                                                onChange={formik.handleChange}
                                                value={formik.values.committed_witness_name}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                        <div className="col-md-12 my-2">
                                            <label htmlFor="committed_witness_address" className='form-label'>Committed Witness Address: <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" className="form-control form-control-sm"
                                                name="committed_witness_address"
                                                id="committed_witness_address"
                                                onChange={formik.handleChange}
                                                value={formik.values.committed_witness_address}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                        <div className="col-md-12 my-2">
                                            <label htmlFor="committed_witness_signature" className='form-label'>Committed Witness Signature: <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                name="committed_witness_signature"
                                                id="committed_witness_signature"
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files[0];
                                                    // Check if the uploaded file is an image
                                                    if (file && !file.type.startsWith("image/")) {
                                                        toast.error("Please upload a valid image file.");
                                                        event.target.value = ""; // Clear the file input
                                                        setImagePreview(null); // Clear preview
                                                    } else {
                                                        // Set preview if valid
                                                        formik.setFieldValue("committed_witness_signature", file);
                                                        setImagePreview(URL.createObjectURL(file));
                                                    }
                                                }}
                                                onBlur={formik.handleBlur}
                                            />

                                        </div>
                                        {imagePreview && (
                                            <div style={{ marginTop: "20px", textAlign: "center" }}>
                                                <img src={imagePreview} alt="Preview" style={{ maxWidth: "100%", height: "200px", border: "1px solid black", borderRadius: "5px" }} />
                                            </div>
                                        )}
                                    </div>

                                </>

                            </div>
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                                </button>
                            </div>

                        </form>
                    </Offcanvas.Body>
                </>
            }

        </Offcanvas>
    )
}

export default RenewalModal